import * as React from "react";
import {useEffect} from "react";
import {RaisedButton} from "../common/RaisedButton";
import {raisedButtonClassOnlyStyle} from "../common/buttonStyles";
import {AdminRegion} from "../../api/LoginContentAdminApi";

export enum RegionContentTab {
    COUNTRIES = "countries",
    HERO = "hero",
    CAROUSEL = "carousel",
    PILLS = "pills",
    STATS = "stats"
}

export const SECTION_TABS: {key: RegionContentTab; icon: string; label: string}[] = [
    {key: RegionContentTab.COUNTRIES, icon: "fa-globe", label: "Countries"},
    {key: RegionContentTab.HERO, icon: "fa-heading", label: "Hero Content"},
    {key: RegionContentTab.CAROUSEL, icon: "fa-images", label: "Carousel Cards"},
    {key: RegionContentTab.PILLS, icon: "fa-tags", label: "Service Pills"},
    {key: RegionContentTab.STATS, icon: "fa-chart-bar", label: "Stats Bar"}
];

interface AdminLoginRegionContentTabsProps {
    activeRegion: AdminRegion;
    activeSection: RegionContentTab;
    onSectionChange: (section: RegionContentTab) => void;
}

export const AdminLoginRegionContentTabs: React.FunctionComponent<AdminLoginRegionContentTabsProps> = (props) => {
    const handleSectionChange = (section: RegionContentTab) => {
        props.onSectionChange?.(section);
    };

    useEffect(() => {
        handleSectionChange(RegionContentTab.HERO);
    }, [props.activeRegion.id]);

    return (
        <div className="admin-login-content__section-tabs-row" data-testid="admin-login-content-section-tabs">
            <div className="admin-login-content__section-tabs" role="tablist" aria-label="Content sections">
                {SECTION_TABS.map(tab => {
                    const isActive = props.activeSection === tab.key;
                    const cls = `admin-login-content__section-tab${isActive ? " admin-login-content__section-tab--active" : ""}`;
                    return (
                        <RaisedButton
                            key={tab.key}
                            type="button"
                            className={cls}
                            style={raisedButtonClassOnlyStyle}
                            primary={false}
                            role="tab"
                            aria-selected={isActive}
                            data-section-tab={tab.key}
                            onClick={() => handleSectionChange(tab.key)}
                        >
                            <i className={`fa-solid ${tab.icon}`} />
                            {tab.label}
                        </RaisedButton>
                    );
                })}
            </div>
            <div className="admin-login-content__context-chip">
                <i className="fa-solid fa-globe" />
                <span>{props.activeRegion.regionName}</span>
                {props.activeRegion.languageCode && (
                    <span className="admin-login-content__context-chip-lang">
                        {props.activeRegion.languageCode.toUpperCase()}
                    </span>
                )}
                <span className={
                    "admin-login-content__context-chip-dot"
                    + (props.activeRegion.published
                        ? " admin-login-content__context-chip-dot--live"
                        : "")
                } aria-hidden="true" />
            </div>
        </div>
    );
};